module.exports = "./dist/assets/images/icons/823539a1e859ff288095345976c1f452.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/mghabitat.png
// module id = ./assets/images/icons/mghabitat.png
// module chunks = 0